export enum Farol {
    VERDE = 'VERDE',
    AMARELO = 'AMARELO',
    VERMELHO = 'VERMELHO',
    ROXO = 'ROXO'
}